import { getIsBitSet } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
export default function isDateHeaderEnabled() {
    return !getIsBitSet(2 /* DateHeadersDisabled */);
}
//# sourceMappingURL=isDateHeaderEnabled.js.map